// Wait for n milliseconds (promise)
export function wait(ms) {
    return new Promise(function (r) {
        return setTimeout(r, ms)
    })
}

// Throttle
export function throttle(func, delay) {
    let timer = null
    return function () {
        const _this = this
        const args = []
        for (let _len = arguments.length, _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key]
        }
        if (timer === null) {
            timer = setTimeout(function () {
                func.apply(_this, args)
                timer = null
            }, delay)
        }
    }
}

// Injection d'une icon svg
export function icon(id, addClass) {
    return (
        '<svg class="svg svg-' +
        id +
        (addClass ? ' ' + addClass : '') +
        '" aria-label="icon"><use xlink:href="#' +
        id +
        '"></use></svg>'
    )
}

// Traitement des chaines de caractères pour la recherche
// (suppression des diacritics + minuscule)
export function normalizeString(str) {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
}
